module.exports = __webpack_public_path__ + "img/choose.0d174d89.svg";